<template>
  <div class="row">
    <div class="col">
      <div class="card card-modern">
        <div class="card-body">
          <div class="datatables-header-footer-wrapper">
            <div class="datatable-header">
              <div class="row align-items-center mb-3">
                <div class="col-3 mb-3 mb-lg-0">
                  <router-link
                    class="btn btn-primary btn-md font-weight-semibold btn-py-2 px-4"
                    :to="{ name: 'AddSlider' }"
                  >
                    + Dodaj slider
                  </router-link>
                </div>
                <div
                    class="col-9 ps-lg-1 mb-3 mb-lg-0 d-flex justify-content-end align-items-center gap-1"
                  >
                    <treeselect
                      v-model="contentType"
                      class="w-25 custom-vue-tree-select"
                      :options="b2bOrb2cOptions"
                      placeholder="B2B/B2C"
                    />
                    <div class="d-flex align-items-lg-center">
                      <select
                        class="form-control select-style-1 results-per-page"
                        name="results-per-page"
                        v-model="searchConfig.pageSize"
                        @change="changePageSize(searchConfig.pageSize)"
                      >
                        <option
                          :value="page"
                          v-for="page in pageSizeList"
                          :key="page"
                        >
                          {{ page }}
                        </option>
                      </select>
                    </div>

                    <div class="search search-style-1 search-style-1-lg">
                      <div class="input-group">
                        <input
                          type="text"
                          class="search-term form-control"
                          placeholder="Search"
                          v-model="searchField"
                          @input="debounceInput"
                        />
                        <button class="btn btn-default" type="submit">
                          <i class="bx bx-search"></i>
                        </button>
                      </div>
                    </div>
                </div>
              </div>
            </div>

            <div
              class="dataTables_wrapper dt-bootstrap5 no-footer"
              v-if="list && list.length > 0"
            >
              <div class="row justify-content-between">
                <div class="col-auto"></div>
                <div class="col-auto"></div>
              </div>
              <div class="table-responsive">
                <table
                  class="table table-ecommerce-simple table-striped mb-0 dataTable no-footer"
                >
                  <thead>
                    <tr role="row">
                      <th class="sorting_disabled">
                        <input
                          type="checkbox"
                          class="select-all checkbox-style-1 p-relative top-2"
                          v-model="selectAll"
                        />
                      </th>
                      <th class="sorting">Rbr</th>
                      <th class="sorting">Interni naziv</th>
                      <th class="sorting">Redoslijed</th>
                      <th class="sorting">Vidljivo na webu?</th>
                      <th class="sorting">Slika</th>
                      <th class="sorting">Glavni opis</th>
                      <th class="sorting">Sporedni opis</th>
                      <th class="sorting">Datum kreiranja</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      role="row"
                      v-for="(jumbotron, index) in list"
                      :key="jumbotron.id"
                      @click="openDetails(jumbotron.id)"
                      :class="{ odd: index % 2 === 0, even: index % 2 !== 0 }"
                    >
                      <td width="30">
                        <input
                          type="checkbox"
                          class="checkbox-style-1 p-relative top-2"
                          :value="jumbotron.id"
                          v-model="selected"
                          @click.stop
                        />
                      </td>
                      <td>
                        <strong>{{
                          (pager.currentPage - 1) * searchConfig.pageSize +
                          index +
                          1
                        }}</strong>
                      </td>
                      <td>
                        <strong>{{ jumbotron.internalTitle }}</strong>
                      </td>
                      <td @click.stop>
                        <div class="order-cell">
                          <div class="order-badges">
                            <span
                              v-if="isB2B(jumbotron)"
                              class="order-badge"
                              title="Redoslijed prikaza B2B"
                            >
                              <span class="order-badge-label">B2B</span>
                              <span class="order-badge-value">{{ jumbotron.displayOrder }}</span>
                            </span>
                            <span
                              v-if="isB2C(jumbotron)"
                              class="order-badge"
                              title="Redoslijed prikaza B2C"
                            >
                              <span class="order-badge-label">B2C</span>
                              <span class="order-badge-value">{{ jumbotron.displayOrderB2C }}</span>
                            </span>
                          </div>
                          <i
                            class="bx bx-pencil order-edit"
                            role="button"
                            title="Izmijeni redoslijed"
                            @click.stop="openOrderModal(jumbotron)"
                          ></i>
                        </div>
                      </td>
                      <td class="sorting">
                        {{ jumbotron.isVisibleOnWeb ? 'Da' : 'Ne' }}
                      </td>
                      <td class="sorting">
                        <img
                          class="thumb"
                          :src="`${baseUrl}${jumbotron.image}`"
                        />
                      </td>
                      <td class="sorting">{{ jumbotron.mainDescription }}</td>
                      <td class="sorting">
                        {{ jumbotron.secondaryDescription }}
                      </td>
                      <td>{{ formatDate(jumbotron.createdDate) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else>
              <div class="alert alert-info" role="alert">
                {{ translations.noRecords }}
                <a class="alert-link" @click.prevent="resetFilters">{{
                  translations.resetFilters
                }}</a
                >.
              </div>
            </div>
            <hr class="solid mt-5 opacity-4" />
            <div class="datatable-footer">
              <div class="row align-items-center justify-content-between mt-3">
                <div class="col-md-auto order-1 mb-3 mb-lg-0">
                  <div class="d-flex align-items-stretch">
                    <div
                      class="d-grid gap-3 d-md-flex justify-content-md-end me-4"
                    >
                      <select
                        class="form-control select-style-1 bulk-action"
                        name="bulk-action"
                        v-model="bulkAction"
                        style="min-width: 170px"
                      >
                        <option value="bulkAction">Bulk Actions</option>
                        <option value="delete">Delete</option>
                      </select>

                      <button
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#delete-modal"
                        class="bulk-action-apply text-color-dark text-3 btn btn-light border btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
                      >
                        {{ translations.apply }}
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row row-gutter-sm justify-content-between mt-4">
                  <pagination :action="actionName" :pagination-props="paginationProps" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal id="delete-modal">
      <h5 slot="header">
        <strong>{{ translations.deleteSelected }}</strong>
      </h5>
      <div slot="body">
        <span v-html="modalText"> </span>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              type="button"
              class="btn btn-primary px-4 mx-2"
              @click.prevent.stop="handleBulkAction"
              data-bs-dismiss="modal"
            >
              {{ translations.yes }}
            </button>
            <button
              type="button"
              class="btn btn-default px-4"
              data-bs-dismiss="modal"
            >
              {{ translations.no }}
            </button>
          </div>
        </div>
      </div>
    </modal>

    <modal id="order-modal">
      <h5 slot="header">
        <strong>Izmjena redoslijeda prikaza</strong>
      </h5>
      <div slot="body">
        <div v-if="orderEdit">
          <p class="mb-3">
            <strong>{{ orderEdit.internalTitle }}</strong>
          </p>
          <div class="form-group mb-3" v-if="isB2B(orderEdit)">
            <label class="mb-1">Redoslijed prikaza B2B</label>
            <input
              type="number"
              min="1"
              class="form-control form-control-modern"
              v-model.number="orderB2B"
            />
          </div>
          <div class="form-group" v-if="isB2C(orderEdit)">
            <label class="mb-1">Redoslijed prikaza B2C</label>
            <input
              type="number"
              min="1"
              class="form-control form-control-modern"
              v-model.number="orderB2C"
            />
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              type="button"
              class="btn btn-primary px-4 mx-2"
              :disabled="savingOrder"
              @click.prevent.stop="saveOrder"
            >
              {{ translations.save }}
            </button>
            <button
              type="button"
              class="btn btn-default px-4"
              data-bs-dismiss="modal"
            >
              {{ translations.cancel }}
            </button>
          </div>
        </div>
      </div>
    </modal>
    <!-- end: page -->
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import { translations, pager } from '@/mixins';
import config from '@/config';
import api from '@/services/api';
import Pagination from '../../shared/Pagination.vue';
import Modal from '../../shared/modal/Modal.vue';

export default {
  name: 'Jumbotrons',
  components: { Treeselect, Pagination, Modal },
  mixins: [translations, pager],
  data() {
    const { query } = this.$route;

    return {
      actionName: 'getJumbotrons',
      deleteActionName: 'deleteJumbotrons',
      bulkActionName: 'deleteJumbotrons',
      contentType: query?.contentType || null,
      orderEdit: null,
      orderB2B: null,
      orderB2C: null,
      savingOrder: false,
    };
  },
  computed: {
    b2bOrb2cOptions() {
      return [
        { id: 1, label: 'B2B' },
        { id: 2, label: 'B2C' },
        { id: 3, label: 'Sve' },
      ];
    },
    list() {
      return this.$store.getters.getJumbotrons;
    },
    modalText() {
      return this.translations.areYouSureSelected;
    },
    baseUrl() {
      return config.baseUrl;
    },
    paginationProps() {
      return {
        contentType: this.contentType,
      };
    },
  },
  mounted() {
    this.$store.dispatch(this.actionName, { ...this.searchConfig, ...this.paginationProps });
  },
  methods: {
    openDetails(id) {
      this.$router.push({ name: 'EditSlider', params: { id: id } });
    },
    isB2B(jumbotron) {
      return jumbotron.jumbotronContentType == 1 || jumbotron.jumbotronContentType == 3;
    },
    isB2C(jumbotron) {
      // 2 = B2C, 3 = Both
      return jumbotron.jumbotronContentType == 2 || jumbotron.jumbotronContentType == 3;
    },
    openOrderModal(jumbotron) {
      this.orderEdit = jumbotron;
      this.orderB2B = jumbotron.displayOrder;
      this.orderB2C = jumbotron.displayOrderB2C;
      $('#order-modal').modal('show');
    },
    async saveOrder() {
      if (this.savingOrder || !this.orderEdit) return;
      this.savingOrder = true;

      try {
        const { data } = await api.getJumbotronById(this.orderEdit.id);
        const slider = data.data;

        const formData = new FormData();
        formData.append('title', slider.title || '');
        formData.append('internalTitle', slider.internalTitle || '');
        formData.append('id', slider.id);
        formData.append('mainDescription', slider.mainDescription || '');
        formData.append('secondaryDescription', slider.secondaryDescription || '');
        formData.append('alignment', slider.alignment || '');
        formData.append('contentUrl', slider.contentUrl || '');
        formData.append('fusnote', slider.fusnote || '');
        formData.append('linkText', slider.linkText || '');
        formData.append('isVisibleOnWeb', slider.isVisibleOnWeb || false);
        formData.append('isDefaultContent', slider.isDefaultContent || false);
        formData.append('imagePxWidth', slider.imagePxWidth || 0);
        formData.append('imagePxHeight', slider.imagePxHeight || 0);
        formData.append('mobileImagePxWidth', slider.mobileImagePxWidth || 0);
        formData.append('mobileImagePxHeight', slider.mobileImagePxHeight || 0);
        formData.append('titleColour', slider.titleColour || '');
        formData.append('titleFontSize', slider.titleFontSize || '');
        formData.append('mainDescriptionColour', slider.mainDescriptionColour || '');
        formData.append('mainDescriptionFontSize', slider.mainDescriptionFontSize || '');
        formData.append('secondaryDescriptionColour', slider.secondaryDescriptionColour || '');
        formData.append('secondaryDescriptionFontSize', slider.secondaryDescriptionFontSize || '');
        formData.append('jumbotronContentType', slider.jumbotronContentType || 3);
        formData.append('displayOrder', this.orderB2B || slider.displayOrder || 1);
        formData.append('displayOrderB2C', this.orderB2C || slider.displayOrderB2C || 1);

        (slider.jumbotronInterestsAreas || []).forEach((item) => {
          formData.append('interestsAreasIds', item);
        });

        await api.updateJumbotron(formData);

        this.$toast.info('Redoslijed prikaza je uspješno ažuriran.');
        $('#order-modal').modal('hide');
        this.orderEdit = null;
        this.$store.dispatch(this.actionName, {
          ...this.searchConfig,
          ...this.paginationProps,
        });
      } catch (e) {
        this.$toast.error('Došlo je do greške prilikom ažuriranja redoslijeda prikaza.');
      } finally {
        this.savingOrder = false;
      }
    },
  },
  watch: {
    contentType() {
      this.$store.dispatch(this.actionName, { ...this.searchConfig, ...this.paginationProps });
      this.$router
        .push({
          query: {
            ...this.searchConfig,
            ...this.paginationProps,
            page: 1,
          },
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.thumb {
  width: 200px;
  height: 80px;
  overflow: hidden;
}
.sorting {
  cursor: pointer;
}

tbody tr {
  cursor: pointer;
}

.order-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}

.order-badges {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.order-badge {
  display: inline-flex;
  align-items: center;
  overflow: hidden;
  border: 1px solid #d0d0d0;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  color: #212529;
}

.order-badge-label {
  padding: 3px 6px;
  background-color: #eceff3;
  color: #5a6570;
}

.order-badge-value {
  min-width: 26px;
  padding: 3px 8px;
  text-align: center;
  background-color: #fff;
}

.order-edit {
  cursor: pointer;
  font-size: 18px;
  color: #0088cc;
  flex-shrink: 0;
}

.order-edit:hover {
  color: #005f8c;
}
</style>

<style lang="scss">
.vue-treeselect {
  min-height: 47px;
}

.vue-treeselect__control {
  min-height: 47px;
}

.custom-vue-tree-select .vue-treeselect__control {
  border: 1px solid #e7e7e7;
}

.vue-treeselect__value-container {
  min-height: 47px;
}

.results-per-page {
  min-width: 60px;
}
</style>
